// import Vue from "vue";
// import Router from "vue-router";
import module from "./module";
import Index from "@views/moblie/home/Index";
import Search from "@views/moblie/shop/GoodSearch";
import Category from "@views/moblie/shop/GoodsClass";
import ShoppingCart from "@views/moblie/shop/ShoppingCart";
import GoodsList from "@views/moblie/shop/GoodsList";
import NotDefined from "@views/moblie/NotDefined";
import Loading from "@views/moblie/Loading";

// Vue.use(Router);

const routerMoblie = [
  {
    path: "/",
    name: "Index",
    meta: {
      title: "首頁",
      keepAlive: true,
      footer: true,
      backgroundColor: "#fff",
      auth: false
    },
    component: Index
  },
  {
    path: "/about-letuopin",
    name: "AboutLetuopin",
    meta: {
      title: "产品信息",
      keepAlive: false,
      auth: false
    },
    component: () => import("@views/moblie/home/AboutLetuopin.vue")
  },
  {
    path: "/district-area",
    name: "DistrictArea",
    meta: {
      title: "停发区域",
      keepAlive: false,
      auth: false
    },
    component: () => import("@views/moblie/home/DistrictArea.vue")
  },
  {
    path: "/clinical-trial",
    name: "ClinicalTrial",
    meta: {
      title: "临床试验",
      keepAlive: false,
      auth: false
    },
    component: () => import("@views/moblie/home/letuopin/ClinicalTrial.vue")
  },
  {
    path: "/clinical-trial-coqun",
    name: "ClinicalTrialCoqun",
    meta: {
      title: "临床试验",
      keepAlive: false,
      auth: false
    },
    component: () => import("@views/moblie/home/letuopin/ClinicalTrialCoqun.vue")
  },
  {
    path: "/listing-certification",
    name: "ListingCertification",
    meta: {
      title: "关于乐托品",
      keepAlive: false,
      auth: false
    },
    component: () =>
      import("@views/moblie/home/letuopin/ListingCertification.vue")
  },
  {
    path: "/manu-info",
    name: "ManuInfo",
    meta: {
      title: "关于乐托品",
      keepAlive: false,
      auth: false
    },
    component: () => import("@views/moblie/home/letuopin/ManuInfo.vue")
  },
  {
    path: "/manu-info-coqun",
    name: "ManuInfoCoqun",
    meta: {
      title: "厂家资料",
      keepAlive: false,
      auth: false
    },
    component: () => import("@views/moblie/home/letuopin/ManuInfoCoqun.vue")
  },
  {
    path: "/questions",
    name: "Questions",
    meta: {
      title: "常見問題",
      keepAlive: false,
      auth: false
    },
    component: () => import("@views/moblie/home/Questions.vue")
  },
  {
    path: "/questions_coqun",
    name: "QuestionsCoqun",
    meta: {
      title: "常見問題",
      keepAlive: false,
      auth: false
    },
    component: () => import("@views/moblie/home/QuestionsCoqun.vue")
  },  
  {
    path: "/customer/chat/:id/:productId?",
    name: "CustomerService",
    meta: {
      title: "客服聊天",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/moblie/user/CustomerService.vue")
  },
  {
    path: "/category/:pid?",
    name: "GoodsClass",
    meta: {
      title: "產品分類",
      keepAlive: true,
      footer: true,
      backgroundColor: "#fff"
    },
    component: Category
  },
  {
    path: "/collection",
    name: "GoodsCollection",
    meta: {
      title: "收藏商品",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/moblie/shop/GoodsCollection.vue")
  },
  {
    path: "/search",
    name: "GoodSearch",
    meta: {
      title: "搜索商品",
      keepAlive: true,
      backgroundColor: "#fff"
    },
    component: Search
  },
  {
    path: "/news_detail/:id",
    name: "NewsDetail",
    meta: {
      title: "資訊詳情",
      keepAlive: true,
      backgroundColor: "#fff"
    },
    component: () => import("@views/moblie/shop/news/NewsDetail.vue")
  },
  {
    path: "/news_list",
    name: "NewsList",
    meta: {
      title: "資訊",
      keepAlive: true,
      backgroundColor: "#fff"
    },
    component: () => import("@views/moblie/shop/news/NewsList.vue")
  },
  {
    path: "/evaluate_list/:id",
    name: "EvaluateList",
    meta: {
      title: "商品評分",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/shop/EvaluateList.vue")
  },
  {
    path: "/goods_evaluate/:id",
    name: "GoodsEvaluate",
    meta: {
      title: "商品評價",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/shop/GoodsEvaluate.vue")
  },
  {
    path: "/promotion",
    name: "GoodsPromotion",
    meta: {
      title: "促銷單品",
      keepAlive: false
    },
    component: () => import("@views/moblie/shop/GoodsPromotion.vue")
  },
  {
    path: "/hot_new_goods/:type",
    name: "HotNewGoods",
    meta: {
      title: "熱門榜單",
      keepAlive: false
    },
    component: () => import("@views/moblie/shop/HotNewGoods.vue")
  },
  {
    path: "/detail/:id",
    name: "GoodsCon",
    meta: {
      title: "商品詳情",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/moblie/shop/GoodsCon.vue")
  },
  {
    path: "/shop/storeList/:gonames?",
    name: "StoreList",
    meta: {
      title: "門店列表",
      keepAlive: false
    },
    component: () => import("@views/moblie/shop/StoreList.vue")
  },
  {
    path: "/shop/HospitalList/details",
    name: "HospitalList",
    meta: {
      title: "門店列表",
      keepAlive: false
    },
    component: () => import("@views/moblie/shop/HospitalList.vue")
  },
  {
    path: "/cart",
    name: "ShoppingCart",
    meta: {
      title: "購物車",
      keepAlive: true,
      footer: true,
      auth: true
    },
    component: ShoppingCart
  },
  {
    path: "/goods_list",
    name: "GoodsList",
    meta: {
      title: "商品列表",
      keepAlive: true
    },
    component: GoodsList
  },
  {
    path: "/register",
    name: "Register",
    meta: {
      title: "註冊",
      keepAlive: true
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "@views/moblie/user/Register.vue")
  },
  {
    path: "/change_password",
    name: "ChangePassword",
    meta: {
      title: "修改密碼",
      keepAlive: true,
      backgroundColor: "#fff",
      auth: true
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "@views/moblie/user/ChangePassword.vue")
  },
  {
    path: "/retrieve_password",
    name: "RetrievePassword",
    meta: {
      title: "找回密碼",
      keepAlive: true
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "@views/moblie/user/RetrievePassword.vue")
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      title: "登錄",
      keepAlive: true
    },
    component: () =>
      import(/* webpackChunkName: "login" */ "@views/moblie/user/Login.vue")
  },
  ...module,
  {
    path: "/auth/:url",
    name: "Loading",
    meta: {
      title: "加載中",
      keepAlive: true
    },
    component: Loading
  },
  {
    path: "*",
    name: "NotDefined",
    meta: {
      title: "頁面找不到",
      keepAlive: true,
      home: false,
      backgroundColor: "#F4F6FB"
    },
    component: NotDefined
  }
];

export default routerMoblie;
